// Phase 5B — Firecrawl inventory sync API client.
import { apiFetch } from './client';

export const inventorySyncApi = {
  triggerFirecrawl: ({ dealerId } = {}) =>
    apiFetch('/api/inventory/sync/firecrawl', {
      method: 'POST',
      body: dealerId ? { dealer_id: dealerId } : {},
    }),
  list: (params) => apiFetch('/api/inventory/sync-runs', { params }),
  get: (id) => apiFetch(`/api/inventory/sync-runs/${id}`),
};
